<template>
    <div class="page_content" aria-label="connection Page Content">

        <!--
        <div class="mt-5 pg_msg">
            <span>
                Identify someone in your network who has knowledge of one of your career ideas.
                First goto the specific career idea by clicking below on the idea and then create a connection by clicking "create connection".

            </span>
        </div>
        -->

        <div class="mt-3">
            <div class="row page-heading mx-0 connection_head">
                <div class="col-xl-6 col-lg-6 col-md-5 col-sm-5 col-5 input module_heading">
                    <!--
                    <span class="pg_icon icon-job"></span>
                    <span class="module_head" @click="navigateToCareerIdeas">Career Ideas</span>
                    <span class="head_sep"> > </span>
                    -->
                    <span class="module_subhead">
                        <span class="icon icon-job"></span> <span class="career-name ace_sec_hd" role="heading" aria-level="1" :aria-label="careerIdea.title">{{careerIdea.title}}</span>
                    </span>

                </div>
                <div class="col-xl-6 col-lg-6 col-md-7 col-sm-7 col-7 submit btn-container">
                    <button type="button" class="btn btn-primary create-conn" @click.prevent="create" aria-label="create connection">create connection</button>
                     <button type="button" class="btn btn-primary mobile-create-conn" @click.prevent="create" aria-label="create connection">create</button>

                	<div class="select-interest-level mr-5">
	                	<span class="module_type_name">Interest:</span>
	                    <span class="interest_level">
	                        <span v-if="careerIdea.interestLevel === '1'">High</span>
                            <span v-if="careerIdea.interestLevel === '2'">Medium</span>
                            <span v-if="careerIdea.interestLevel === '3'">Low</span>
	                    </span>
                    </div>
                </div>
            </div>

            <div class="mt-3">
                <connection-list :career-idea-id="careerIdeaId"></connection-list>
            </div>
        </div>

    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import ConnectionList from './ConnectionList'

  export default {
    name: 'connection',
    props: ['careerIdeaId'],
    data () {
      return {
        careerIdea: {},
        interestLevelOptions: [
          {value: '3', text: 'Low'},
          {value: '2', text: 'Medium'},
          {value: '1', text: 'High'}
        ]
      }
    },
    components: {
      ConnectionList
    },

    mounted () {
      if (this.careerIdeaId) {
        this.populateCareerIdeaDetail()
      }
    },

    methods: {
      ...mapActions([
        'loadCareerIdeaDetail'
      ]),

      populateCareerIdeaDetail () {
        this.loadCareerIdeaDetail(this.careerIdeaId).then(res => {
          this.careerIdea = res
        })
      },

      create () {
        return this.$router.push({name: 'connectionCreate', params: {careerIdeaId: this.careerIdea.uuid, careerIdea: this.careerIdea}})
      },

      navigateToCareerIdeas () {
        return this.$router.push({ name: 'careerIdea' })
      }
    }
  }
</script>

<style scoped>
    select {
        width: 70px;
        height: 22px !important;
    }
</style>



// WEBPACK FOOTER //
// src/app/quest/components/Connection.vue